import { useMutation } from "@tanstack/react-query";

export default useMutation;
